module.exports = __webpack_public_path__ + "img/Scalability.cd7c92a8.svg";